export default {"src":"/_next/static/media/norway.66abb8ee.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};